import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

function Pagination({
  itemsDisplaying, items, itemsPerPage, handleNext, handlePrevious,
}) {
  const currentPage = Math.ceil(itemsDisplaying / itemsPerPage);
  const totalPages = Math.ceil(items.length / itemsPerPage);
  const canGoPrevious = itemsDisplaying > itemsPerPage;
  const canGoNext = itemsDisplaying < items.length;

  return (
    <div className="flex items-center justify-center space-x-4">
      {/* Previous Button */}
      <button
        type="button"
        onClick={handlePrevious}
        disabled={!canGoPrevious}
        className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
          canGoPrevious
            ? 'bg-gray-700 text-white hover:bg-gray-600 hover:shadow-lg active:scale-95'
            : 'bg-gray-800 text-gray-500 cursor-not-allowed'
        }`}
      >
        <FontAwesomeIcon icon={faChevronLeft} className="text-sm" />
        <span>Previous</span>
      </button>

      {/* Page Info */}
      <div className="flex items-center space-x-2 text-gray-300">
        <span className="text-sm font-medium">Page</span>
        <span className="bg-gray-700 px-3 py-1 rounded-md text-white font-semibold">
          {currentPage}
        </span>
        <span className="text-sm font-medium">of</span>
        <span className="bg-gray-700 px-3 py-1 rounded-md text-white font-semibold">
          {totalPages}
        </span>
      </div>

      {/* Next Button */}
      <button
        type="button"
        onClick={handleNext}
        disabled={!canGoNext}
        className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-all duration-300 ${
          canGoNext
            ? 'bg-blue-600 text-white hover:bg-blue-700 hover:shadow-lg active:scale-95'
            : 'bg-gray-800 text-gray-500 cursor-not-allowed'
        }`}
      >
        <span>Next</span>
        <FontAwesomeIcon icon={faChevronRight} className="text-sm" />
      </button>
    </div>
  );
}

export default Pagination;

Pagination.propTypes = {
  itemsDisplaying: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    name: PropTypes.string,
    post_title: PropTypes.string,
    post_type: PropTypes.string,
    post_content: PropTypes.string,
    post_date: PropTypes.string,
    guid: PropTypes.string,
    view_count: PropTypes.number,
  })).isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  handleNext: PropTypes.func.isRequired,
  handlePrevious: PropTypes.func.isRequired,
};
